export default angular.module('cian.newbuild.filter.apiService', [])

.factory('ApiService', ['$http', '$log', '$q', 'UserService', ($http, $log, $q, UserService) => {
  const baseUrl = '/ajax/';

  function get(url, config) {
    return $http.get(baseUrl + url, config);
  }

  function post(url, data, config) {
    return $http.post(baseUrl + url, data, config);
  }

  /**
   * Throws errors to console if options is not passed or has wrong type
   *
   * Usage example:
   *   // inside method
   *   const expected = { email: 'string' }
   *   checkAllOptionsPassed('sendEmail', options, expected)
   *
   *   // when use method
   *   ApiService.sendEmail({ email: 'something@ya.ru' }) // nothing in console
   *   ApiService.sendEmail({}) // Error: You must pass option email to ApiService.sendEmail method
   *   ApiService.sendEmail({ email: 123 }) // Error: Option email should be a string
   *
   * @private
   */
  function checkAllOptionsPassed(method, actualOptions, expectedOptions) {
    for (const option in expectedOptions) {
      if (actualOptions[option] === void 0) { // === undefined
        $log.error(`You must pass option ${option} to ApiService.${method}method`);
      } else if (typeof actualOptions[option] !== expectedOptions[option]) {
        $log.error(`Option ${option} should be a ${expectedOptions[option]}`);
      }
    }
  }

  return {
    getScheme: (regionId) => {
      return get(`search/metro/${regionId}/`, {cache: true});
    },
    /**
     * @param  {Object} opts
     *   @property {string} email
     * @return {Promise}
     */
    saveSearch: opts => {
      const options = opts || {};
      // //master.dev.cian.ru/ajax/subscriptions
      // шлет данные на //www.cian.ru/ajax/subscriptions с параметрами:
      // action:subscribe
      // email:werwer@m.ru
      // deal_type:sale
      // filter_params://www.cian.ru/cat.php?currency=2&deal_type=sale&engine_version=2&minprice=11&offer_type=flat&region=1
      checkAllOptionsPassed('saveSearch', options, {
        // email: 'string', // email is optional
        // dealType: 'string', // optional
        filterParams: 'string', // url
      });


      // для залогиненых пользователей сохраняем поиск и по желанию включаем рассылку
      if (UserService.isAuthenticated()) {
        return post('stored_filters', {
          action: 'store',
          email: options.email,
          deal_type: options.dealType,
          title: options.title,
          subscribe: options.email ? 'on' : null,
          filter_params: options.filterParams,
        });
      }

      // для незалогиненых пользователей только включаем рассылку
      return post('subscriptions', {
        action: 'subscribe',
        email: options.email,
        title: options.title,
        filter_params: options.filterParams,
      });
    },
    /**
     * @param {string} type - состоит из категории и типа сделки (например flatsale или suburbanrent)
     * @return {object}
     */
    getDefaultFilterForType: type =>
      require(`!json!../autogenerated-default-filters/${type.toLowerCase()}.json`),
    getQueryMeta: (jsonQuery, sourceConfig={}) => {
      const {isArchivePage, ...config} = sourceConfig;
      const requestUrl = '/cian-api/site/v1/offers/search/meta/';

      var def = $q.defer();

      $log.debug('Get offers meta: ', jsonQuery, config);
      $http.post(requestUrl, jsonQuery, config).success(data => {
        if (data.status === 'error') {
          def.reject(data.message);
        } else {
          def.resolve(data.data);
        }
      }).error(() => {
        def.reject('Error getting meta for JSON Query');
      }).catch(err => {
        // -1 — отменили сами
        if (err.status !== -1) {
          $log.debug('Error getting meta for JSON Query');
        }
      });

      return def.promise;
    },
    getOffers: (jsonQuery, isTable) => {
      var def = $q.defer();

      $log.debug('Get offers: ', jsonQuery);

      let postLink = '/cian-api/site/v1/offers/search/';

      $http.post(postLink, jsonQuery)
        .success(data => {
          if (data.status === 'error') {
            def.reject(data.message);
          } else {
            def.resolve(data.data);
          }
        })
        .error(() => {
          def.reject('Error getting data for JSON Query');
        })
        .catch(() => {
          $log.debug('Error getting data for JSON Query');
        });

      return def.promise;
    },
    // Без слэша на конце не будет работать
    publishOffer: opts => post('publish-offer/', {
      realtyObjectId: opts.offerId,
      autoProlong: opts.autoprolong,
      publishServices: opts.publishServices,
    }),
  };
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/services/api.service.js